





























































































import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import moment from "moment";
import TabBar from "@/components/TabBar.vue";
import { API_BASE_URL, BUDGET_PERIOD_OPTIONS, DATE } from "@/shared/global-values";
import IUser from "@/types/user";

export default Vue.extend({
  components: {
    TabBar,
  },
  data() {
    return {
      user: {} as IUser,
      budgetPeriodOptions: BUDGET_PERIOD_OPTIONS,
      dateOptions: DATE,
      isDisabled: false,
      isDisabledSave: false,
    };
  },
  async created(): Promise<void> {
    const id: string = localStorage.getItem("userId") as string;

    try {
      const token: string = await firebase.auth().currentUser!.getIdToken();
      const response: AxiosResponse = await axios.get(`${API_BASE_URL}/users/${id}`, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
      this.user = response.data.user as IUser;

      const dateDay: HTMLSelectElement = this.$refs.dateDay as HTMLSelectElement;
      const dateMonth: HTMLSelectElement = this.$refs.dateMonth as HTMLSelectElement;
      const dateYear: HTMLSelectElement = this.$refs.dateYear as HTMLSelectElement;

      const date: Date = new Date(this.user.budgetRolloverFrom);

      dateDay.value = date.getDate().toString();
      dateMonth.value = DATE.MONTHS[date.getMonth()];
      dateYear.value = date.getFullYear().toString();

    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    isSelected(budgetPeriod: string): boolean {
      return budgetPeriod === this.user.budgetPeriod;
    },
    selectBudgetPeriod(event: Event): void {
      const span: HTMLSpanElement = event.currentTarget as HTMLSpanElement;
      this.user.budgetPeriod = span.dataset.budgetPeriod as string;
    },
    async save(event: Event): Promise<void> {
      this.isDisabledSave = true;

      const id: string = localStorage.getItem("userId") as string;

      const dateDay: HTMLSelectElement = this.$refs.dateDay as HTMLSelectElement;
      const dateMonth: HTMLSelectElement = this.$refs.dateMonth as HTMLSelectElement;
      const dateYear: HTMLSelectElement = this.$refs.dateYear as HTMLSelectElement;
      const dateString: string = `${dateDay.value}-${dateMonth.value}-${dateYear.value}`;

      const form: HTMLFormElement = event.currentTarget as HTMLFormElement;
      const formData: FormData = new FormData(form);

      formData.set("budget_rollover_from", moment(dateString, "D-MMMM-YYYY").toISOString());
      formData.set("has_budget_rollover", this.user.hasBudgetRollover.toString());

      try {
        const token: string = await firebase.auth().currentUser!.getIdToken();
        await axios.put(`${API_BASE_URL}/users/${id}`, formData, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
        this.$router.push({ name: "Home" });

      } catch (error) {
        console.error(error);
      }
    },
    async signOut(): Promise<void> {
      this.isDisabled = true;

      const formData: FormData = new FormData();

      try {
        const token: string = await firebase.auth().currentUser!.getIdToken();
        await axios.post(`${API_BASE_URL}/auth/invalidate_token`, formData, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
        await firebase.auth().signOut();

      } catch (error) {
        console.error(error);
      }
    },
  },
});
